// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bb7012d1","239":"a78bcd50","455":"2a93ce68"}[chunkId] + ".chunk.js";
};